import React, { useMemo } from 'react';

// Components
import { GIButton } from 'app-components';
import { ConditionalRendering } from '../../../../components/common/conditional-rendering';

// Hooks
import { useCurrentServerDate, useModal } from '../../../../hooks';

// Utils
import { isCoverageValid } from '../planSummary.utils';

// Constants
import { ENROLLMENT_ACTIONS, PLAN_TYPE } from '../../../../modules/custom-grouping/modals/modalTypes';

// Styles
import { StyledDisenrollActionContainer } from '../plansummary.styled';
import usePlanSummary from '../hooks/usePlanSummary';
import { ICheckForPendingAppRequest, IDisenrollPlanActionProps } from '../planSummary.types';

const DisenrollPlanAction = ({ plan, hasPermission }: IDisenrollPlanActionProps) => {
    const { coverageStartDate, coverageEndDate, typeOfPlan } = plan;
    const currentDate = useCurrentServerDate();
    const { checkForPendingApplication } = usePlanSummary();
    const { openModal } = useModal();

    const isValidCoverage = useMemo(
        () => isCoverageValid(coverageStartDate, coverageEndDate, currentDate),
        [coverageStartDate, coverageEndDate],
    );

    const getButtonText = () => {
        return isValidCoverage ? `plansummary.${typeOfPlan.toLowerCase()}.disenrollplan` : 'plansummary.cancelCoverage';
    };

    const actionButtonClick = () => {
        const request = {} as ICheckForPendingAppRequest;
        if (plan.typeOfPlan.toUpperCase() === PLAN_TYPE.HEALTH) {
            request.healthPlan = plan;
        } else {
            request.dentalPlan = plan;
        }
        request.openModal = openModal;
        request.action = isValidCoverage ? ENROLLMENT_ACTIONS.SUBMIT : ENROLLMENT_ACTIONS.CACNEL;
        checkForPendingApplication(request);
    };

    if (!plan.disEnroll) {
        return null;
    }

    return (
        <ConditionalRendering isTrue={plan.disEnroll && hasPermission}>
            <ConditionalRendering isTrue={isValidCoverage !== null}>
                <StyledDisenrollActionContainer>
                    <GIButton
                        id={isValidCoverage ? `disenrollment_${typeOfPlan.toLowerCase()}_plan_btn` : `cancel_${typeOfPlan.toLowerCase()}_coverage_btn`}
                        data-testid={isValidCoverage ? `disenrollment_${typeOfPlan.toLowerCase()}_plan_btn` : `cancel_${typeOfPlan.toLowerCase()}_coverage_btn`}
                        labelId={getButtonText()}
                        onClickHandler={actionButtonClick}
                    />
                </StyledDisenrollActionContainer>
            </ConditionalRendering>
        </ConditionalRendering>
    );
};

export default DisenrollPlanAction;
